import { ContactActionModal } from "@/components/mirror/ContactActionModal";
import type { ContactActionPrefill } from "@/lib/contactExecutor";
import type { ModuleCaptureHandler } from "@/lib/capture/types";

const text = (value: unknown, max: number) => typeof value === "string" ? value.trim().slice(0, max) : "";
export const contactCaptureHandler: ModuleCaptureHandler<ContactActionPrefill> = {
  tool: "propose_contact_action",
  getRawText: proposal => {
    if (proposal.tool !== "propose_contact_action") return "";
    const args = proposal.args as unknown as Record<string, unknown>;
    return JSON.stringify({ action: text(args.action, 20), provider: text(args.provider, 30), query: text(args.query, 200),
      item_id: text(args.item_id, 1500), given_name: text(args.given_name, 200), family_name: text(args.family_name, 200),
      email: text(args.email, 254), phone: text(args.phone, 80) });
  },
  extract: async (_raw, proposal, ctx) => {
    if (proposal.tool !== "propose_contact_action" || !ctx.ownerId || !ctx.sessionId) return null;
    const args = proposal.args as unknown as Record<string, unknown>;
    if (!["search", "create", "update", "delete"].includes(String(args.action)) ||
      !["auto", "google_contacts", "microsoft_contacts"].includes(String(args.provider ?? "auto"))) return null;
    return { action: args.action as ContactActionPrefill["action"], provider: (args.provider ?? "auto") as ContactActionPrefill["provider"],
      query: text(args.query, 200), item_id: text(args.item_id, 1500) || undefined,
      given_name: typeof args.given_name === "string" ? text(args.given_name, 200) : undefined,
      family_name: typeof args.family_name === "string" ? text(args.family_name, 200) : undefined,
      email: typeof args.email === "string" ? text(args.email, 254) : undefined,
      phone: typeof args.phone === "string" ? text(args.phone, 80) : undefined,
      action_id: proposal.action_id, expected_user_id: ctx.ownerId, expected_session_id: ctx.sessionId };
  },
  renderModal: ({ open, prefill, onClose, onCreated }) => (
    <ContactActionModal open={open} prefill={prefill} onClose={onClose} onCreated={onCreated} />
  ),
};
